import { Dispatch } from 'redux';

import { Client, Company } from 'src/constants';
import { arrayToMap } from 'src/utils/array';

import { Events } from '../constants/webSocketConsts/events';
import { Invoice, invoicesApi } from '../services/api/invoicesApi';

import { updateListCache } from './updateListCache';

// An invoice can be generated server-side (e.g. by a subscription cycle) after
// this client loaded its list, so a MODIFY for an unseen invoice must add it.
const listCacheOptions = { insertMissingOnModify: true };

export function handleInvoiceUpdate(
  event: Events,
  items: Invoice[],
  dispatch: Dispatch<any>,
  companies: Company[],
  clients: Client[],
) {
  dispatch(
    invoicesApi.util.updateQueryData(
      'getInvoices',
      undefined,
      (draft?: Invoice[]) => {
        updateListCache(event, items, draft, listCacheOptions);
      },
    ),
  );

  for (const item of items) {
    const {
      clientId: invoiceClientId,
      companyId,
      recipientId: invoiceRecipientId,
    } = item;
    const invoiceId = item.id;

    const companiesMap = arrayToMap(companies, 'id');
    // If found, this indicates that this is a company invoice
    const company = companiesMap.get(companyId || invoiceRecipientId);

    if (company && !invoiceClientId) {
      const companyClientsIds = clients
        .filter(
          (client) =>
            // TODO:(enable_many_companies) remove the companyId check once we enable many companies
            client.fields.companyId === invoiceRecipientId ||
            client.fields.companyIds?.includes(invoiceRecipientId),
        )
        .map((client) => client.id);
      for (const clientId of companyClientsIds) {
        dispatch(
          invoicesApi.util.updateQueryData(
            'getInvoicesByRecipientId',
            {
              clientId,
              companyId: company.id,
              includeCompanyInvoices: Boolean(clientId && company.id),
            },
            (draft?: Invoice[]) => {
              updateListCache(event, items, draft, listCacheOptions);
            },
          ),
        );
      }
    } else {
      const queryParamClientId = invoiceClientId || invoiceRecipientId;
      dispatch(
        invoicesApi.util.updateQueryData(
          'getInvoicesByRecipientId',
          {
            clientId: queryParamClientId,
            companyId,
            includeCompanyInvoices: Boolean(queryParamClientId && companyId),
          },
          (draft?: Invoice[]) => {
            updateListCache(event, items, draft, listCacheOptions);
          },
        ),
      );
    }

    dispatch(
      invoicesApi.util.updateQueryData(
        'getInvoicesByRecipientId',
        {
          clientId: undefined,
          companyId,
          includeCompanyInvoices: false,
        },
        (draft?: Invoice[]) => {
          updateListCache(event, items, draft, listCacheOptions);
        },
      ),
    );

    // Updating cache for any invoices for invoice details view
    dispatch(
      invoicesApi.util.updateQueryData(
        'getInvoiceById',
        invoiceId,
        (draft?: Invoice) => {
          if (!draft) {
            return;
          }
          Object.assign(draft, item);
        },
      ),
    );
  }
}
